import React from "react";
import { Navigate } from "react-router-dom";
import { getCurrentUser } from "../services/auth";

const PrivateRoute = ({ children }) => {
  const user = getCurrentUser();

  if (user) {
    return children;
  }

  if (localStorage.getItem("logoutReason")) {
    localStorage.removeItem("postLoginRedirect");
  } else {
    localStorage.setItem(
      "postLoginRedirect",
      window.location.pathname + window.location.search
    );
  }

  return <Navigate to="/login" replace />;
};

export default PrivateRoute;
